import { useState } from "react";
import api from '../../api/axios';
import './reset-pw.css';
import { useTranslation } from 'react-i18next';

function ResetPasswordPopUp({ trigger, setTrigger }) {
    const { t } = useTranslation();
    const [email, setEmail] = useState('');
    const [resetMessage, setResetMessage] = useState('');
    const [formSubmitted, setFormSubmitted] = useState(false);

    const handleChange = (e) => {
        setEmail(e.target.value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Anpassung: URL an unseren Server???
            await api.post('/user/reset-password', { email });
            setResetMessage('Eine E-Mail zum Zurücksetzen des Passworts wurde gesendet.');
            setFormSubmitted(true);
        } catch (error) {
            console.error('Fehler beim Senden der Passwort-Reset-E-Mail', error);
            setResetMessage('Fehler: E-Mail konnte nicht gesendet werden.');
            setFormSubmitted(false);
        }
    };

    const handleBackToLogin = () => {
        setFormSubmitted(false);
        setTrigger(false);
    };

    return trigger ? (
        <div className="ResetPasswordPopUp-wrapper">
            <div className="ResetPasswordPopUp-inner">
                <button className="close-btn-reset" onClick={() => setTrigger(false)}>&times;</button>
                <h2>{t('HeaderResetPW')}</h2>
                {!formSubmitted ? (
                    <>
                        <p>{t('ResetPWText')}</p>
                        <form id="reset-form" onSubmit={handleSubmit}>
                            <label htmlFor="emailReset">{t('EMailAddress')}</label>
                            <input
                                type="email"
                                id="emailReset"
                                name="email"
                                placeholder={t('EnterEMail')}
                                onChange={handleChange}
                                required
                            />
                            <button type="submit" id="resetButton">{t('SendLink')}</button>
                            <p className="reset-message"><em>{resetMessage}</em></p>
                        </form>
                    </>
                ) : (
                    <>
                        <p className="reset-message"><em>{resetMessage}</em></p>
                        <button onClick={handleBackToLogin} id="backToLoginButton">{t('BackLogin')}</button>
                    </>
                )}
            </div>
        </div>
    ) : null;
}

export default ResetPasswordPopUp;